import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import CompanyInvestor from './CompanyInvestor'
import CompanyInvestorActivity from './CompanyInvestorActivity'

function CompanyInvestorMain(props) {
    window.scrollTo(0, 0)
    const [param, setParam] = useState("cu");
    const { companyName } = useParams();
    
    const [companySymbol, setcompanySymbol] = useState('');
    if (companyName != companySymbol) {
        setcompanySymbol(companyName)
    }

    useEffect(() => {
    }, [])


    return (
        <div className="Home" style={{ backgroundColor: "rgb(248, 248, 252)", fontSize: "14px", minHeight: "650px", marginLeft: "10px", marginRight: "10px", paddingBottom: "110px", paddingTop: "90px" }}>
            <div style={{ padding: "5px 110px" }}>
                <div className="CompanyNav" style={{ padding: "10px 0px 0px 0px" }}>

                    <div className="CompanyMenu" id="current" onClick={() => {
                        setParam('cu')
                    }
                    } style={param === "cu" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Current</div>
                    <div className="CompanyMenu" id="Activity" onClick={() => {
                        setParam('ac')
                    }
                    } style={param === "ac" ? { backgroundColor: '#000', color: '#fff' } : { backgroundColor: "rgb(221, 219, 240)", color: '#3e424b' }}>Activity</div>
                    
                </div>
                <div style={{ padding: "10px 0px 0px 0px" }} >
                    {param === "cu" &&
                        <CompanyInvestor companySymbol={companySymbol}/>
                    }
                    {param === "ac" &&
                        <CompanyInvestorActivity companySymbol={companySymbol}/>
                    }
                </div>
            </div>
        </div>
    );
}
export default CompanyInvestorMain;